import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { AccountManagement } from '../../models/account-management';
import { CognitoChangeRequestFrom } from '../../models/cognito-change-request-from';
import { CognitoChangeRequestTo } from '../../models/cognito-change-request-to';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.css']
})
export class AccountManagementComponent implements OnInit {

  model: AccountManagement;
  errorMessage: string = null;
  displaySuccessMsg: boolean;

  constructor(private accountService: AccountService, public router: Router) {
    this.model = new AccountManagement();
    this.accountService.getAccountManagementInfo()
    .subscribe((res) => this.receiveAccountManagementInfo(res), res => this.errorMessage = this.accountService.handleError(res));

   }

  ngOnInit() {
  }

  receiveAccountManagementInfo(res: AccountManagement) {
    this.model = res;
  }

  onAccept(item: CognitoChangeRequestFrom) {
    this.accountService.acceptCognitoRequest(item)
    .subscribe(res => this.acceptResponse(res), res => this.errorMessage = this.accountService.handleError(res));
  }

  onDeny(item: CognitoChangeRequestFrom) {
    this.accountService.denyCognitoRequest(item)
    .subscribe(res => this.refreshInfo(), res => this.errorMessage = this.accountService.handleError(res));
  }

  onCancel(item: CognitoChangeRequestTo) {
    this.accountService.cancelCognitoRequest(item)
    .subscribe(res => this.refreshInfo(), res => this.errorMessage = this.accountService.handleError(res));
  }

  refreshInfo() {
    this.accountService.getAccountManagementInfo()
    .subscribe((res) => this.receiveAccountManagementInfo(res), res => this.errorMessage = this.accountService.handleError(res));
  }

  acceptResponse(res: string)
  {
    if (res !== "success")
    {
      this.errorMessage = res;
    }
    else {
      localStorage.clear();
      this.displaySuccessMsg = true;
    }
  }
  
  listTrack(o) {
    return o;
  }

  logOut(){
    //Logout
    this.router.navigate(['/logout']);
  }

}
